var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50065 0.583313C12.8729 0.583313 16.4173 4.12773 16.4173 8.49998C16.4173 12.8722 12.8729 16.4166 8.50065 16.4166C4.1284 16.4166 0.583984 12.8722 0.583984 8.49998C0.583984 4.12773 4.1284 0.583313 8.50065 0.583313ZM4.77447 4.7738C5.0602 4.48807 5.5085 4.46609 5.81924 4.70786L5.89389 4.7738L8.50085 7.38076L11.1078 4.7738C11.4173 4.46426 11.9177 4.46426 12.2272 4.7738C12.513 5.05953 12.5349 5.50783 12.2932 5.81857L12.2272 5.89322L9.62027 8.50018L12.2272 11.1071C12.5368 11.4167 12.5368 11.917 12.2272 12.2266C12.0728 12.3809 11.8702 12.4585 11.6675 12.4585C11.4986 12.4585 11.3297 12.4046 11.1888 12.2973L11.1078 12.2266L8.50085 9.61959L5.89389 12.2266C5.73952 12.3809 5.53685 12.4585 5.33418 12.4585C5.13152 12.4585 4.92885 12.3809 4.77447 12.2266C4.48874 11.9408 4.46676 11.4925 4.70854 11.1818L4.77447 11.1071L7.38143 8.50018L4.77447 5.89322C4.46493 5.58368 4.46493 5.08334 4.77447 4.7738Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailIcon);
export default __webpack_public_path__ + "static/media/failIcon.1880345e.svg";
export { ForwardRef as ReactComponent };